/* eslint-disable  @typescript-eslint/no-explicit-any */
import { getWithAuth } from '@/api/httpRequests'
import { getFromLocalStorage } from '@/shared/localStorage/localStorageRepository'
import { useVODService } from '@/app/context/DIContext/DIServices'
import {
    IVODServiceStreamIQ,
    NewVodData,
} from '@/shared/types/services/types/vodService/IVodServiceStreamIQ'
import { SearchResultType } from '@/types/search/searchResultType'
import { configLsKeyword } from '@/api/toya/apiConstantsCodespot'
import { getBootstraps } from '@/clients/streamiq/shared/lib'

export const mapNewVodDataToSearchResultType = (
    vodData: NewVodData
): SearchResultType => {
    const configObject = getFromLocalStorage(configLsKeyword)

    const bootstrapsKeyword = JSON.parse(configObject || '')
    return {
        audioChannelConfig: null,
        description: vodData.description,
        duration: vodData.runtime || null,
        externalDeepLinkAddress: null,
        internalDeepLinkContentId: vodData.id,
        internalDeepLinkType: vodData.type,
        isContentLive: false,
        posterUrl:
            vodData.sourceImages.find(
                (image) => image.size === 'medium' || image.size === 'small'
            )?.url ||
            bootstrapsKeyword.skin.appMenuLogoUrl ||
            '',
        productionYear: vodData.releaseDate
            ? new Date(vodData.releaseDate).getFullYear()
            : null,
        purchasePrice: null,
        rentalPrice: null,
        title: vodData.title,
        serviceName: vodData.serviceName,
    }
}

export const useSearchResultsStreamIQ = () => {
    const { fetchVodItemDetails } = useVODService() as IVODServiceStreamIQ
    const bootstraps = getBootstraps()

    const url = bootstraps?.services?.['search-service'].resource

    const getSearchResults = async (query: string) => {
        const res = await getWithAuth(`${url}?`, false, {
            search: query,
        })
        if (!res) return

        const { response } = res

        if (response) {
            const rawFetchResult = await Promise.allSettled(
                response.resources.map(async (item: any) =>
                    fetchVodItemDetails(
                        item.reference.id,
                        item.reference.type,
                        item.reference.serviceName
                    )
                )
            )

            const fetchResult = rawFetchResult
                .filter((result: any) => result.status === 'fulfilled')
                .map((result: any) => result.value)
                .filter((item: any) => Boolean(item))

            return {
                searchResults: fetchResult.map((item) =>
                    mapNewVodDataToSearchResultType(item)
                ),
            }
        }
    }

    return { getSearchResults }
}
